module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Uxpg5D/tc-custom/9780802192219.jpg?1705549508318",
      "alt": "This image is the cover for the book Legends of the Fall"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Legends of the Fall\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Three novellas by the "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestselling author, including the classic tale of brotherhood from the Montana plains through the horrors of WWI.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Jim Harrison’s critically acclaimed novella “Legends of the Fall”—which was made into the film of the same name—is an epic tale of three brothers fighting for justice in a world gone mad. Moving from the expansive landscape of early twentieth-century Montana to the blood-drenched battlefields of World War I Europe, Harrison explores the desperate actions of which men are capable when their lives or aspirations are threatened."), _c('br'), _vm._v(" Also including the novellas “Revenge” and “The Man Who Gave Up His Name,” "), _c('i', [_vm._v("Legends of the Fall")]), _vm._v(" confirms Jim Harrison’s reputation as a writer who “stands high among the writers of his generation. This book is rich, alive, and shatteringly visceral. A triumph” ("), _c('i', [_vm._v("New Yorker")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("“I can’t begin to do justice to the nuances of character and honest complexities of plot in this work. The writing is precise and careful—and sings withal.” —Raymond Carver, "), _c('i', [_vm._v("Washington Post Book World")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jim Harrison\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0